export default {
    "validation.length": "Valor máximo deve ser 5 caracteres",
    "codProjeto": "Cód. Projeto",
    "nomeProjeto": "Nome Projeto",
    "statusCadastrado": "Status Cadastrado",
    "codPacote": "Cód. Pacote",
    "nomePacote": "Nome Pacote",
    "numOrdemDeInvestimento": "Nº. Ordem de Investimento (OI)",
    "ordemDeInvestimento": "Ordem de Investimento (OI)",
    "numeroRequisicaoDeCompra": "N° Requisição de Compra",
    "itemRequisicaoCompra": "Item Requisição de Compra",
    "statusRequisicaoCompra": "Status Requisição de Compra",
    "numeroOrdemDeCompra": "N° Ordem de Compra",
    "dataEmissaoOrdemDeCompra": "Dt. Emissão Ordem de Compra",
    "status": "Status",
    "numeroPedido": "N° Pedido",
    "tipoPedido": "Tipo Pedido",
    "nomeFornecedor": "Nome Fornecedor",
    "numeroContratado": "N° Contrato",
    "numeroCentroDeCusto": "N° Centro de Custo",
    "numeroContaContabil": "N° Conta Contábil",
    "totalProjeto": "Total de Iniciativas",
    "naoPrevisto": "Não Previsto",
    "orcadoAno": "Orçado Ano",
    "forecastAno": "Forecast Ano",
    "variacao": "Variação",
    "tiposDePacote": "Tipos de Pacote",
    "tipoDeProjetoForecast": "Disciplina de Projeto X Forecast",
    "resumoDoCapEx": "Resumo do CapEx R$ M",
    "diretoria": "Diretoria",
    "area": "Área",
    "departamento": "Departamento",
    "equipamento": "Equipamento",
    "servico": "Serviço",
    "material": "Material",
    "capex": "Capex",
    "contratado": "Contratado",
    "executado": "Executado",
    "requisitado": "Requisitado",
    "aContratar": "A Contratar",
    "forecast": "Forecast",
    "saldoCapex": "SaldoCapex",
    "codCentroDeCusto": "Cód. Centro de Custo",
    "numCentroDeCusto": "Nº. Centro de Custo",
    "nomeCentroDeCusto": "Nome Centro de Custo",
    "codAgrupador": "Cód. Agrupador",
    "acronimoAgrupador": "Acrôn. Agrupador",
    "nomeAgrupador": "Nome Agrupador",
    "contaContabil": "Conta Contábil",
    "dataRequisicaoCompra": "Data da Requisição de Compra",
    'mensagemNaoProcessado': "Existem registros previamente importados mas que ainda não foram consolidados. Ao importar uma nova planilha, todos os registros atualmente importados serão perdidos. Confirmar importação de nova Planilha?",
    'mensagemProcessado': "Existem registros previamente importados e consolidados. A importação de uma nova planilha irá impactar os valores dos relatórios do sistema. Confirmar importação de nova Planilha?",
    'orcado': 'Orçado',
    'buildUpR$M': 'Build Up R$ M',
    'lblNomeDoProjeto': 'Nome do Projeto',
    'lblSolicitante': 'Solicitante',
    'lblNome': 'Nome',
    'lblFuncao': 'Função',
    'lblDepartamentoAreaDiretoria': 'Departamento/ Área/ Diretoria',
    'lblDiretoriaAreaDepartamento': 'Diretoria/ Área/ Departamento',
    'lblEscopoDoProjetoEOuInvestimento': 'Escopo do Projeto e/ou Investimento',
    'lblVidaUtilEmMeses': 'Vida útil (em meses)',
    'lblMotivadorDoCapExNaoPrevisto': 'MOTIVADOR DO NÃO PREVISTO',
    'lblTipo': 'Tipo',
    'lblObservacao': 'Observação',
    'lblPorQueAgora': 'Por que agora',
    'lblDetalhe': 'Detalhe',
    'lblDetalhes': 'Detalhes',
    'lblContratacaoNecessaria': 'Contratação necessária',
    'lblEngenharia': 'Engenharia',
    'lblMateriaisEquipamentos': 'Materiais/ Equipamentos',
    'lblConstrucao': 'Contrução',
    'lblOutros': 'Outros',
    'lblFornecedorDirecionadoSwitch': 'Fornecedor direcionado?',
    'lblFornecedorDirecionado': 'Fornecedor direcionado',
    'lblFornecedor': 'Forncedor',
    'lblSim': 'Sim',
    'lblNao': 'Não',
    'lblRfa': 'RFA',
    'lblEmergencial': 'Emergencial',
    'lblTradeOff': 'Trade-off',
    'lblMaturidadeEOuNivelDeDefinicao': 'Maturidade e/ou nível de definição',
    'lblEngConceitual': 'Eng. Conceitual',
    'LblEngBasica': 'Eng. Básica',
    'LblEngDetalhada': 'Eng. Detalhada',
    'lblConsultivaViaGa': 'Consultiva via GA',
    'lblDepDeclaracaodoEscopoDoProjeto': 'DEP - Declaração do Escopo do Projeto',
    'lblBalancoOrcamento': 'Balanço Orçamento (R$M)',
    'lblOrcamentoAprovado': 'Orçamento Aprovado',
    'lblForecastDoMes': 'Forecast do Mês',
    'lblNaoPrevistosAprovados': 'Não Previstos Aprovados',
    'lblImpactoNoForecast': 'Impacto no Forecast Econômico',
    'lblForecastAtualizado': 'Forecast Atualizado Econômico',
    'lblImpactoNoForecastFinanceiro': 'Impacto no Forecast Financeiro',
    'lblForecastAtualizadoFinaceiro': 'Forecast Atualizado Financeiro',
    'lblTaxaUs': 'Taxa (US$)',
    'lblTaxaEuro': 'Taxa (EURO)',
    'lblDocumentoAnexos': 'Documentos Anexos',
    'lblOrcamento': 'Orçamento Econômico',
    'lblOrcamentoFinanceiro': 'Orçamento Financeiro',
    'lblPacoteTipoEDisciplina': 'Pacote (Tipo e Disciplina)',
    'lblDescricaoDoPacote': 'Descrição do Pacote',
    'lblJaneiro': 'Janeiro',
    'lblFevereiro': 'Fevereiro',
    'lblMarco': 'Março',
    'lblAbril': 'Abril',
    'lblMaio': 'Maio',
    'lblJunho': 'Junho',
    'lblJulho': 'Julho',
    'lblAgosto': 'Agosto',
    'lblSetembro': 'Setembro',
    'lblOutubro': 'Outubro',
    'lblNovembro': 'Novembro',
    'lblDezembro': 'Dezembro',
    'lblTotal': 'Total',
    'lblTotalReais': 'TOTAL R$',
    'lblTotalDolar': 'TOTAL US$',
    'lblRecursosParaExecucaoEconomiasEmOutrosProjetos': 'Recursos para execução (economias em outros projetos)',
    'lblSeHouverRecursoInformarOProjeto': 'Se houver recurso, informar o Projeto',
    'lblCodProjeto': 'Cód. Projeto',
    'lblNTotvs': 'Nº TOTVS',
    'lblValorDisponibilizadoR$': 'Valor disponibilizado R$',
    'lblValorTotalDisponibilizadoRS': 'Valor total disponibilizado R$',
    'lblControladoria': 'Controladoria',
    'lblAprovacao': 'Aprovação',
    "lblAreaDiretoriaSolicitante": "Área / Diretoria Solicitante",
    "lblAreaDiretoria": "Área / Diretoria",
    "lblGestaoEControle": " Gestão e Controle",
    "lblParecerDaDiretoriaEstatuaria": " Parecer da Diretoria Estatutária ",
    "lblComentarioParecer": "Comentários / Parecer",
    "lblResponsavel": "Responsável",
    "placeholder_escopo": "Informar o que será feito/adquirido",
    "placeholder_vidaUtilEmMeses": "Informar a vida útil do Ativo",
    "placeholder_observacao": "Justificar a escolha do motivador",
    "placeholder_porQueAgora": "Informar porque é necessário o CNP/ONP neste ano e não pode esperar para entrar no ciclo orçamentário do ano seguinte",
    "lblAcao": "Ação",
    "lblSigla": "Sigla",
    "lblDisciplina": "Disciplina",
    "lblContaContabil": "Conta Contábil",
    "lblAgrupador": "Agrupador",
    "lblProjeto": "Projeto",
    "lblValidacoesEAprovacoes": "Validações e Aprovações",

    "lblValidacaoGerenciaGFG": "Validação Gerência GFG",
    "lblValidacaoAdministrador": "Validação Administrador",
    "lblValidacaoGDGPP": "Validação (GD GPP)",
    "lblGerenteGeralAreaSolicitante": "Gerente Geral Área Solicitante",
    "lblDiretorAreaSolicitante": "Diretor Área Solicitante",
    "lblGerenteGeralGP": "Gerente Geral GP",
    "lblDiretorImplantacao": "Diretor Implantação",
    "lblDiretorSustentabilidade": "Diretor Sustentabilidade",
    "lblDiretorOperacoes": "Diretor Operações",
    "lblDiretorFinanceiro": "Diretor Financeiro",
    "lblDiretorPresidente": "Diretor Presidente",
}